export enum ROUTES {
  GET = '/get',
  TRACK_INFO = '/track-info',
}
